module.exports = __webpack_public_path__ + "img/core_hecheng.bc821536.png";